import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { EntityPath, Protocol, url } from '@environments/environment';
import { IChangePaswordRequest, IPersonDataAsync, IUser, IUserPayload, IUserResponse, TOwnerSettings } from '@app-profile/data-access/entities/profile.interface';
import { TranslateAdapter } from 'src/shared/helpers/translateAdapter';
import { UserDataDictionary } from '../entities/profile.dictionary';
import { EGenderType, ERegistrationType, GenderTypeMap, RegistrationTypeMap } from '../entities/profile.enum';

@Injectable({ providedIn: 'root' })
export class ProfileService {
    private http = inject(HttpClient);
    private getUserDataDictionary = new TranslateAdapter(UserDataDictionary);

    public changeSelfUserPassword(payload: IChangePaswordRequest): Observable<boolean> {
        return this.http.post<boolean>(url(Protocol.https, EntityPath.user_service, '/Auth/ChangePassword'), payload, {
            withCredentials: true,
        });
    }

    public getUserData(): Observable<IUser> {
        return this.http.get<IUser>(url(Protocol.https, EntityPath.base, '/Contas/Usuario'), {
            withCredentials: true,
        });
    }

    public getOwnerSettings(): Observable<TOwnerSettings> {
        return this.http.get<TOwnerSettings>(url(Protocol.https, EntityPath.account_service, '/OwnerSettings/GetAsync'), {
            withCredentials: true,
        });
    }

    public getUserDataAsync(): Observable<IUser> {
        return this.http.get<IPersonDataAsync>
        (url(Protocol.https, EntityPath.person_service, '/Person/GetUserDataAsync'), { 
            withCredentials: true }
        ).pipe(map((e: any) => {
            if (!e) return null;
                const adapter: any =  this.getUserDataDictionary.translate(e);
                if (!adapter) return null;
                adapter.Sexo = GenderTypeMap[adapter?.Sexo as EGenderType];
                adapter.TipoCadastro = RegistrationTypeMap[adapter?.TipoCadastro as ERegistrationType];
                return adapter;
            }))
    }

    public updateUserData(payload: IUserPayload): Observable<IUserResponse> {
        return this.http.put<IUserResponse>(url(Protocol.https, EntityPath.base, '/Contas/Usuario'), payload, {
            withCredentials: true,
        });
    }
}
